import React from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius, p} from "@pg-design/helpers-css";
import {GoogleNewsIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";

export const ArticleGoogleNewsSubscription = () => {
    const url = "https://news.google.com/publications/CAAqBwgKMPrIlwswnPKuAw?hl=pl&gl=PL&ceid=PL:pl";
    const responsiveLinkTarget = useResponsiveLinkTarget();

    return (
        <a css={articleGoogleNewsSubscription} href={url} target={responsiveLinkTarget} rel="noopener norefferer">
            <Text as="p" variant="headline_4" fontFamily="secondary">
                {concatWithBrandName("Subskrybuj")} w Google News
            </Text>
            <GoogleNewsIcon size="6" wrapperSize="6" wrapperColor="transparent" />
        </a>
    );
};

const articleGoogleNewsSubscription = (theme: Theme) => css`
    background-color: #fff;
    display: flex;
    ${p(4)};
    ${borderRadius(2)};
    justify-content: space-between;
    align-items: center;

    &:hover {
        color: ${theme.colors.secondary};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius, p} from "@pg-design/helpers-css";
import {GoogleNewsIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";

export const ArticleGoogleNewsSubscription = () => {
    const url = "https://news.google.com/publications/CAAqBwgKMPrIlwswnPKuAw?hl=pl&gl=PL&ceid=PL:pl";
    const responsiveLinkTarget = useResponsiveLinkTarget();

    return (
        <a css={articleGoogleNewsSubscription} href={url} target={responsiveLinkTarget} rel="noopener norefferer">
            <Text as="p" variant="headline_4" fontFamily="secondary">
                {concatWithBrandName("Subskrybuj")} w Google News
            </Text>
            <GoogleNewsIcon size="6" wrapperSize="6" wrapperColor="transparent" />
        </a>
    );
};

const articleGoogleNewsSubscription = (theme: Theme) => css`
    background-color: #fff;
    display: flex;
    ${p(4)};
    ${borderRadius(2)};
    justify-content: space-between;
    align-items: center;

    &:hover {
        color: ${theme.colors.secondary};
    }
`;
